module.exports = __webpack_public_path__ + "media/pricing/bg-2bac1607.svg";